let toggler = document.querySelector(".braks-header #checkbox")
let mobilemenu = document.querySelector(".barks-mobile-mobile")
let navigation = document.querySelector(".barks-nav")
let body = document.querySelector("body")
const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')
let droplink = document.querySelectorAll(".barks-linkbox span");
let dropmenu = document.querySelectorAll(".barks-linkproduct-box .bark-products-row");


var swiper = new Swiper("#barks-bestsellers", {
    slidesPerView: 5.3,
    spaceBetween: 35,
    speed:500,
    autoplay:{
        delay:2000,
    },
     breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 20,
            centeredSlides: true,
          loop:true,
        },
        1000: {
          slidesPerView: 4,
          spaceBetween: 40,
           centeredSlides: false,
           loop:false,
        },
        1350: {
           slidesPerView: 5.3,
              spaceBetween: 35,
        },
      },
});




tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})


toggler.addEventListener("click",(el)=>{
  if(el.target.checked){
    mobilemenu.classList.add("barks-menuopen")
    navigation.classList.add("barks-menuactive")
    body.style.overflow = "hidden"
  }
  else{
    mobilemenu.classList.remove("barks-menuopen")
    navigation.classList.remove("barks-menuactive")
    body.style.overflow = "auto"
  }
})


window.addEventListener("scroll",()=>{
  if (window.scrollY > 54) {
     mobilemenu.style.height="calc(100dvh - 20vw)"
  }
    else if (window.scrollY < 54) {
       mobilemenu.style.height="calc(100dvh - 20vw)"
    }
  
})



droplink.forEach((el, index) => {
  el.addEventListener("mouseenter", function () {
    // Remove "dropactive" from all dropmenu elements
    dropmenu.forEach((menu) => {
      menu.classList.remove("dropactive");
    });

    // Remove "droplinkactive" from all droplink elements
    droplink.forEach((link) => {
      link.classList.remove("droplinkactive");
    });

    // Add "dropactive" to the current dropmenu element based on the index
    dropmenu[index].classList.add("dropactive");

    // Add "droplinkactive" to the current droplink element
    el.classList.add("droplinkactive");
  });
});


function toggleAccordion(clickedHeader) {
    const accordionItem = clickedHeader.parentNode;
    const accordionBody = accordionItem.querySelector('.accordion-body');
    const icon = accordionItem.querySelector('.icon');

    // Toggle current accordion
    const isAccordionOpen = accordionBody.classList.toggle('open');
    accordionBody.style.maxHeight = isAccordionOpen ? `${accordionBody.scrollHeight + 20}px` : '0'; /* Add the padding value */
    accordionBody.style.paddingInline = isAccordionOpen ? '10px' : '0'; /* Toggle padding based on accordion state */

    // Toggle rotate class for the icon
    icon.classList.toggle('rotate', isAccordionOpen);

    // Toggle active class for the accordion header
    clickedHeader.classList.toggle('active', isAccordionOpen);

    // If the clicked accordion is open, close the others
    if (isAccordionOpen) {
      const allAccordions = document.querySelectorAll('.accordion-item');
      allAccordions.forEach((item) => {
        if (item !== accordionItem) {
          const otherAccordionBody = item.querySelector('.accordion-body');
          const otherAccordionIcon = item.querySelector('.icon');
          const otherAccordionHeader = item.querySelector('.accordion-header');

          otherAccordionBody.classList.remove('open');
          otherAccordionBody.style.maxHeight = '0';
          otherAccordionBody.style.padding = '0';
          otherAccordionIcon.classList.remove('rotate');
          otherAccordionHeader.classList.remove('active');
        }
      });
    }
  }

document.body.addEventListener('click', function (event) {
    if (event.target.closest('.selectSizeButton')) {
        event.preventDefault();
        
        var variantRadio = document.querySelector('.variantPickrSec input:checked');
        
        if (variantRadio) {
            // document.querySelector('.sr-headless-checkout').click();
        } else {
            if (!document.querySelector('.sizeErrorMessage')) {
                var errorMessage = document.createElement('div');
                errorMessage.id = 'sizeErrorMessage';
                errorMessage.className = 'sizeErrorMessage';
                errorMessage.style.color = 'red';
                errorMessage.style.fontWeight = 'bold';
                errorMessage.textContent = 'Please Select Size';

                var fieldset = document.querySelector('.variantPickrSec fieldset');
                if (fieldset) {
                    fieldset.prepend(errorMessage);
                }
            }

            var variantSection = document.querySelector('.variantPickrSec');
            if (variantSection) {
                window.scrollTo({
                    top: variantSection.offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    }
});




